// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RatO","newExpiryDate":"styles_newExpiryDate__GvFFe","footer":"styles_footer__tKT7c"};